import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const P_SOUCHEACHAT_SCHEMA_LITERAL = {
    title: 'Schéma SoucheAchat',
    description: 'Décrit une souche achat',
    version: 0,
    keyCompression: false,
    primaryKey: 'DO_SOUCHE_STR',
    type: 'object',
    properties: {
        DO_SOUCHE_STR: { type: 'string', maxLength : 20 },
        DO_SOUCHE: { type: 'number' },
        SA_INTITULE: { type: 'string' },
        SA_PRINCIPAL_PSITE: { type: 'boolean' },
        SA_PRINCIPAL_F: { type: 'boolean' }
    },
    required: [ 'DO_SOUCHE', 'SA_INTITULE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(P_SOUCHEACHAT_SCHEMA_LITERAL);
export type RxPSoucheAchatDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const P_SOUCHEACHAT_SCHEMA: RxJsonSchema<RxPSoucheAchatDocumentType> = P_SOUCHEACHAT_SCHEMA_LITERAL;
